import { render } from "./DiamantForm.vue?vue&type=template&id=56acc3bc&scoped=true"
import script from "./DiamantForm.vue?vue&type=script&lang=js"
export * from "./DiamantForm.vue?vue&type=script&lang=js"

import "./DiamantForm.vue?vue&type=style&index=0&id=56acc3bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56acc3bc"]])

export default __exports__